// FILE: src/components/app/SearchBaseComponent/SearchBaseComponent.jsx
import React, { useState } from "react";
import styles from "./SearchBaseComponent.module.css";
import { useAuth } from "../../../../context/AuthContext";
import SearchInput from "./SearchInput/SearchInput";
import SearchResults from "./SearchResults/SearchResults";

export default function SearchBaseComponent() {
  const { user } = useAuth();
  const [query, setQuery] = useState("");
  const [submitted, setSubmitted] = useState("");

  const handleSubmit = (text) => {
    const t = String(text || "").trim();
    setQuery(t);
    setSubmitted(t);
  };

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <h1 className="pp-page-title">Search</h1>
        <p className="text-secondary small mb-0">
          Currently searches <strong>descriptions</strong> only.
        </p>
      </div>

      <SearchInput onSubmit={handleSubmit} placeholder="Search descriptions…" />
      <SearchResults user={user} query={query} submitted={submitted} />
    </div>
  );
}